<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryStockReturnResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">

                                <template #left-header>
                                    <em-button
                                        type='search'
                                        class="btn btn-outline-primary btn-sm"
                                        custom-label="扫码识别"
                                        showName
                                        @click="openScannerDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-warehouse"
                                               :disabled="actionDisabled('selectOne') || notSupportStockReturn()"
                                               custom-label="退库"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openStockReturnDialog()"
                                    >
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="退库" width="30%" :visible.sync="stockReturnDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearReturnForm'>
            <el-form :model="returnForm" ref="returnForm" label-width="auto" size="mini" :rules="rules">
                <el-form-item label="Storage Type" prop="storageType">
                    <el-input v-model="returnForm.storageType"></el-input>
                </el-form-item>
                <el-form-item label="BIN位" prop="storageBin">
                    <el-input v-model="returnForm.storageBin"></el-input>
                </el-form-item>
                <el-form-item label="批次号" prop="batchNumber">
                    <el-input v-model="returnForm.batchNumber"></el-input>
                </el-form-item>
                <el-form-item label="BIN位已占容量" prop="occupiedCapacity">
                    <el-input v-model="returnForm.occupiedCapacity"></el-input>
                </el-form-item>
            </el-form>
            <el-dialog title="扫一扫" :center="true" :visible.sync="binScannerVisible" append-to-body
                       @close="closeBinScanner" :close-on-click-modal='false'>
                <qr-code-scanner ref="binScanner" @getCodeData='getBinInfo'>
                </qr-code-scanner>
            </el-dialog>

            <div slot="footer" class="dialog-footer">
                <el-button @click="openBinScanner()">扫描BIN位码</el-button>
                <el-button @click="stockReturnDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="stockReturn()">确认退库</el-button>
            </div>
        </el-dialog>
        <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" append-to-body
                   @close="closeScannerDialog" :close-on-click-modal='false'>
            <qr-code-scanner ref="returnTaskScanner" @getCodeData='getReturnTask'>
            </qr-code-scanner>
        </el-dialog>
    </div>
</template>
<script>
// Author Lin
// Date 2022-01-19 17:43:54

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";

export default {
    name: "sithMesInventoryStockReturnListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin],
    components: {qrCodeScanner},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            stockReturnDialogVisible: false,
            returnForm: {
                storageType: '',
                storageBin: '',
                batchNumber: '',
                occupiedCapacity: '',
            },
            rules: {
                storageType: [{required: true, message: '请输入StorageType'}],
                storageBin: [{required: true, message: '请输入BIN位'}],
            },
            scannerVisible: false,
            binScannerVisible: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
    },
    mounted() {
        if (this.$route.query.id) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
        }
        if (this.$route.query.orderCode) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', this.$route.query.orderCode);
        }
        if (this.$route.query.materialCode) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', this.$route.query.materialCode);
        }
        this.$refs.emListFilter.doQuery();
    },
    methods: {
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        notSupportStockReturn() {
            let selectedItem = this.$store.state[this.modelName].rows.filter(row => this.$store.state[this.modelName].checkedItems.indexOf(row.id) !== -1)[0];
            return selectedItem.returnTime && selectedItem.storageBin
        },
        openStockReturnDialog() {
            this.stockReturnDialogVisible = true;
        },
        clearReturnForm() {
            this.returnForm.storageType = '';
            this.returnForm.storageBin = '';
            this.returnForm.batchNumber = '';
            this.returnForm.occupiedCapacity = '';
            this.$refs.returnForm.resetFields();
        },
        stockReturn() {
            let self = this;
            self.$refs["returnForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryStockReturn")}/confirmReturn?id=${this.selectIds}`
                    self.$_emApiMixin_post(url, self.returnForm)
                        .then((request) => {
                            if (request.status === 200) {
                                self.$message({
                                    message: "退库完成",
                                    type: "success",
                                });

                                self.$refs.emListFilter.doQuery();
                            } else {
                                self.$message({
                                    message: "退库失败",
                                    type: "error",
                                });
                            }
                        }).finally(() => {
                        this.stockReturnDialogVisible = false;
                    })
                }
            })
        },
        openScannerDialog() {
            this.scannerVisible = true;
            setTimeout(() => {
                this.$refs.returnTaskScanner.openCamera('');
            }, 500);
        },
        openBinScanner() {
            this.binScannerVisible = true;
            setTimeout(() => {
                this.$refs.binScanner.openCamera('');
            }, 500);
        },
        getReturnTask(data) {
            console.log("get qr code data:" + data);
            this.scannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var materialCode = obj['物料号'];
                // var orderCode = obj.orderCode;
                console.log(materialCode);
                // console.log(orderCode);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            // this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', orderCode);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', materialCode);
            this.$refs.emListFilter.doQuery();
        },
        getBinInfo(data) {
            console.log("bin code data:" + data);
            this.binScannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var storageType = obj['Storage Type'];
                var storageBin = obj['Storage Bin'];
                console.log(storageType);
                console.log(storageBin);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            self.returnForm.storageType = storageType;
            self.returnForm.storageBin = storageBin;
        },
        closeScannerDialog() {
            this.$refs.returnTaskScanner.closeCamera();
            this.$refs.returnTaskScanner.resetOutputData();
            this.scannerVisible = false;
        },
        closeBinScanner() {
            this.$refs.binScanner.closeCamera();
            this.$refs.binScanner.resetOutputData();
            this.binScannerVisible = false;
        },
    }
};
</script>
